import './AddForm.css'

import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import { Badge, Card, Popout, PopoutBody, PopoutHeader } from '@sm/wds-react'
import { IconInfo } from '@sm/wds-icons'
import { ConfirmModal } from '../ConfirmModal'
import { LegacyLink } from '../../../../common/components/LegacyLink'
import { hasPermission } from '../../../../common/models/permissions'
import { getUrl, urls } from '../../../../common/utils/urls'
import { getLaunchFBEventDetails } from '../../../../common/models/mixpanel'
import { mixpanel } from '../../../../common/services/telemetry/mixpanel'
import formBuildImage from './images/wf_scratch.png'
import formGalleryImage from './images/wf_template.png'
import formBuildNewImage from './images/wf_newexp.png'
import { CREATE_V2_FORMS_PERMISSION } from '../../../../common/constants/permissions'
import { EAP_EXPERIMENT_NAME, EARLY_ACCESS_FORM_LIMIT } from '../../../../common/constants/experiments'
import {
  EXPERIMENTS_STATE_PROPS,
  FORMSV2_STATE_PROPS,
  PLAN_STATE_PROPS,
  USER_STATE_PROPS,
} from '../../../../common/constants/propTypes/coreWebPropTypes'
import { LAUNCH_LEGACY_LOCATION_CREATE } from '../../../../common/constants/mixpanel'


export let AddForm = props => {

  const {
    dispatch,
    experiments,
    formsV2,
    plan,
    renderTo,
    t,
    user,
  } = props

  const { isInExperiment: isInV2Experiment = false } = experiments.experiments?.[EAP_EXPERIMENT_NAME] || {}
  const canCreateV2Forms = hasPermission(CREATE_V2_FORMS_PERMISSION, plan, user)
  const showCreateV2FormButton = isInV2Experiment && canCreateV2Forms
  const disallowFormCreation = formsV2?.forms?.length >= EARLY_ACCESS_FORM_LIMIT

  const handleClose = () => {
    dispatch({ type: 'CLOSE_MODAL' })
  }

  const renderFormBuilderCard = () => {
    return (
      <div className={classnames(
        'card-wrapper',
        { 'disabled': disallowFormCreation }
      )}
      >
        <Link
          id='form-builder-v2'
          onClick={() => {
            const eventDetails = getLaunchFBEventDetails(LAUNCH_LEGACY_LOCATION_CREATE, { isNewForm: true })
            mixpanel.track(eventDetails.event, eventDetails.properties)
            handleClose()
          }}
          to={getUrl(urls.FORM_BUILDER, {})}
        >
          <Card>
            <div className='card-content'>
              <img
                alt=''
                className='form-builder-img-v2'
                src={formBuildNewImage}
              />
              <div className='text'>
                {t('modals:try_the_new_form_builder')}
              </div>
              <div className='new-experience-popout'>
                <Popout
                  placement='right'
                  trigger={<IconInfo />}
                  renderTo={renderTo}
                >
                  <PopoutHeader>
                    {t('modals:try_new_form_builder_title')}
                  </PopoutHeader>
                  <PopoutBody>
                    {t('modals:try_new_form_builder_body')}
                  </PopoutBody>
                </Popout>
              </div>
            </div>
            <Badge>
              {t('global:Beta')}
            </Badge>
          </Card>
        </Link>
      </div>
    )
  }

  return (
    <ConfirmModal
      className='add-form-modal'
      size='md'
      name='add-form-modal'
      hasFooter={false}
      header={t('modals:add_form_header')}
    >
      <div className='card-container'>
        <div className='form-cards'>
          <LegacyLink
            createFormType='Scratch'
            id='form-builder'
            location={LAUNCH_LEGACY_LOCATION_CREATE}
            to='/build'
          >
            <Card>
              <div className='card-badge'>
                {showCreateV2FormButton && (
                  <Badge>
                    {t('modals:Classic')}
                  </Badge>
                )}
              </div>
              <div className='card-content'>
                <img
                  alt=''
                  className='form-build-img'
                  src={formBuildImage}
                />
                <div className='text'>
                  {t('modals:add_form_from_scratch')}
                </div>
              </div>
            </Card>
          </LegacyLink>
          <LegacyLink
            createFormType='Template'
            id='form-template'
            location={LAUNCH_LEGACY_LOCATION_CREATE}
            to='/gallery/templates'
          >
            <Card>
              <div className='card-badge'>
                {showCreateV2FormButton && (
                  <Badge>
                    {t('modals:Classic')}
                  </Badge>
                )}
              </div>
              <div className='card-content'>
                <img
                  alt=''
                  className='template-img'
                  src={formGalleryImage}
                />
                <div className='text'>
                  {t('modals:add_form_from_template')}
                </div>
              </div>
            </Card>
          </LegacyLink>
        </div>
        {showCreateV2FormButton && (
          <div className='form-cards-v2'>
            {disallowFormCreation ? (
              <Popout
                placement='right'
                trigger={renderFormBuilderCard()}
                renderTo={renderTo}
              >
                <PopoutHeader>
                  {t('modals:form_limit_reached_title')}
                </PopoutHeader>
                <PopoutBody>
                  {t('modals:form_limit_reached_body')}
                </PopoutBody>
              </Popout>
            ) :(
              renderFormBuilderCard()
            )}
          </div>
        )}
      </div>
    </ConfirmModal>
  )
}

AddForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  experiments: PropTypes.shape(EXPERIMENTS_STATE_PROPS).isRequired,
  formsV2: PropTypes.shape(FORMSV2_STATE_PROPS).isRequired,
  plan: PropTypes.shape(PLAN_STATE_PROPS).isRequired,
  renderTo: PropTypes.object,
  t: PropTypes.func.isRequired,
  user: PropTypes.shape(USER_STATE_PROPS).isRequired,
}

const select = state => ({
  experiments: state.experiments,
  formsV2: state.formsV2,
  plan: state.plan,
  user: state.user,
})

AddForm = connect(select)(AddForm)

export default withTranslation([ 'global','modals' ])(AddForm)
